import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppLayoutRoutingModule } from './app-layout-routing.module';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { AppLayoutComponent } from './app-layout.component';
import { MatDialogModule } from '@angular/material/dialog';
import { RegisterComponent } from './register/register.component';
import { LoginComponent } from './login/login.component';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SideNavComponent } from './side-nav/side-nav.component';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../@shared/shared.module';
import { AuthDialogComponent } from './auth-dialog/auth-dialog.component';
import { ForgetPasswordDialogComponent } from './forget-password-dialog/forget-password-dialog.component';
import { ResetPasswordDialogComponent } from './reset-password-dialog/reset-password-dialog.component';
import { SuccessComponent } from '../success/success.component';



@NgModule({
	declarations: [HeaderComponent, SideNavComponent, FooterComponent, AppLayoutComponent, RegisterComponent, LoginComponent, AuthDialogComponent, ForgetPasswordDialogComponent, ResetPasswordDialogComponent, SuccessComponent],
	imports: [
		CommonModule,
		AppLayoutRoutingModule,
		MatDialogModule,
		MatSidenavModule,
		MatToolbarModule,
		MatIconModule,
		MatButtonModule,
		MatListModule,
		MatMenuModule,
		ReactiveFormsModule,
		SharedModule,
		FormsModule
	],
	entryComponents:[ResetPasswordDialogComponent,ForgetPasswordDialogComponent,AuthDialogComponent]
})
export class AppLayoutModule { }
